<template>
  <div class="week">
    <div class="week-head" @click="$emit('toggle', week.startDate)">
      <span class="chevron">{{ isOpen ? "▾" : "▸" }}</span>
      <b>Semana {{ week.number }}</b>
      <span class="text-muted">
        de {{ week.year }} · del {{ week.startDate }} al {{ week.endDate }}
      </span>
      <span v-if="week.isCurrent" class="tag">en curso</span>
      <span class="text-muted ml-auto text-xs">
        {{ week.days.length }} {{ week.days.length === 1 ? "día" : "días" }} ·
        {{ week.kg.toFixed(1) }} kg
      </span>
    </div>

    <el-table
      v-if="isOpen"
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      :data="week.days"
    >
      <el-table-column label="Día" min-width="230px">
        <template v-slot="{row}">
          {{ row.fecha }} · {{ weekdayName(row.fecha) }}
          <span v-if="row.origen === BACKFILLED" class="tag grey">reconstruido</span>
        </template>
      </el-table-column>
      <el-table-column label="Cocina" prop="cocina" min-width="180px"></el-table-column>
      <el-table-column label="Platos" prop="platos" min-width="90px"></el-table-column>
      <el-table-column label="Toppings" prop="filas" min-width="100px"></el-table-column>
      <el-table-column label="Kg" min-width="90px">
        <template v-slot="{row}">{{ row.kg.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="Guardado" min-width="140px">
        <template v-slot="{row}">
          <span class="text-xs text-muted">{{ row.updated_at || row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Reporte" min-width="210px">
        <template v-slot="{row}">
          <base-button
            type="danger"
            size="sm"
            :loading="downloadingId === row.id"
            @click="$emit('download', row)"
          >
            <i class="far fa-file-pdf"></i> PDF
          </base-button>
          <base-button
            type="secondary"
            size="sm"
            :loading="openingId === row.id"
            @click="$emit('show-details', row)"
          >{{ detailsRowId === row.id ? "Ocultar" : "Detalle" }}</base-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="isOpen && details.length" class="details">
      <div class="text-xs text-muted mb-1">
        Detalle guardado de {{ detailsTitle }} — tal como se imprimió.
      </div>
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="details"
        max-height="360"
      >
        <el-table-column label="Topping" prop="nombre" min-width="220px"></el-table-column>
        <el-table-column label="Corte" prop="corte" min-width="130px"></el-table-column>
        <el-table-column label="Porciones" prop="porciones" min-width="100px"></el-table-column>
        <el-table-column label="Kg" min-width="90px">
          <template v-slot="{row}">{{ Number(row.kg).toFixed(2) }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";

const WEEKDAY_NAMES = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];
const BACKFILLED_ORIGIN = "reconstruido";

export default {
  name: "forecast-history-week",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    week: { type: Object, required: true },
    isOpen: { type: Boolean, default: false },
    details: { type: Array, default: () => [] },
    detailsRowId: { type: Number, default: null },
    detailsTitle: { type: String, default: "" },
    downloadingId: { type: Number, default: null },
    openingId: { type: Number, default: null },
  },
  data() {
    return { BACKFILLED: BACKFILLED_ORIGIN };
  },
  methods: {
    weekdayName(isoDate) {
      return WEEKDAY_NAMES[new Date(isoDate + "T00:00:00").getDay()];
    },
  },
};
</script>
<style scoped>
.week {
  border: 1px solid #e2e8e3;
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
}
.week-head {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f4f9f6;
  padding: 9px 12px;
  cursor: pointer;
  font-size: 13px;
}
.week-head:hover {
  background: #eaf4ee;
}
.chevron {
  color: #5dbc85;
  font-size: 11px;
}
.tag {
  background: #5dbc85;
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 8px;
}
.tag.grey {
  background: #e6ebe8;
  color: #6b7a71;
}
.ml-auto {
  margin-left: auto;
}
.details {
  border-top: 1px solid #e2e8e3;
  padding: 8px 12px;
}
</style>
